import { LetterEventName, logLetterEvent, mapToLetterFormStepStringEnum } from "../helpers/logLetterEvent";

import { Button } from "react-migration/components/DeprecatedButton";
import { Icon } from "react-migration/components/Icon";
import { LetterStepper } from "./LetterStepper";
import { clearStore } from "src/js/stores/letter/actions";
import clsx from "clsx";
import { getBackRoute } from "src/js/stores/letter/utils/getBackRoute";
import { letterStore } from "src/js/stores/letter/store";
import { router } from "src/js/router/react-router";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const Header = () => {
  const { t } = useTranslation();
  const { currentStep } = useSnapshot(letterStore);

  const onCloseClick = () => {
    const backRoute = getBackRoute();
    clearStore();
    router.push(backRoute);
  };

  const onLeftButtonClick = () => {
    onCloseClick();
    logLetterEvent({
      name: LetterEventName.LETTERS_FORM_BACK_TO_SITES_CLICKED,
      context: { step: mapToLetterFormStepStringEnum(currentStep) },
    });
  };

  return (
    <div
      data-testid="letters-header"
      className={clsx(
        "w-full",
        "border",
        "py-2",
        "bg-background-surface",
        "px-6",
        "border-b",
        "border-border-action",
        "flex",
        "items-center",
        "relative"
      )}
    >
      <Button.Secondary
        size="large"
        className="gap-1"
        onClick={onLeftButtonClick}
        data-testid="letters-header-left-button"
      >
        <Icon icon="icon-lt-arrow-left-s-line" extraClasses="mr-3 fill-text-base-tertiary" />
        {t("sites.letters.back_to_sites_button")}
      </Button.Secondary>

      <div className={clsx("absolute", "left-1/2", "top-1/2", "-translate-x-1/2", "-translate-y-1/2")}>
        <LetterStepper currentStep={currentStep} />
      </div>
    </div>
  );
};
